export default "__VITE_ASSET__wuGfPAaI__"